import {moment} from "@/src/modules/core/lib/moment";

export type PermitReleaseEntry = {
  /** Calendar day counted toward the limit (`YYYY-MM-DD`). */
  usedOn: string;
  /** Day that permit becomes available again (`YYYY-MM-DD`). */
  releasesOn: string;
};

/** Normalize API / formatter inputs to a calendar-day key. */
export function toPermitDateKey(date: string): string {
  return moment(date).startOf("day").format("YYYY-MM-DD");
}

/**
 * One counted permit day frees on `usedOn + rollingDays` (inclusive range walk).
 */
export function getPermitReleaseSchedule(
  startsAt: string,
  endsAt: string,
  rollingDays: number,
): PermitReleaseEntry[] {
  if (!Number.isFinite(rollingDays) || rollingDays < 0) return [];

  const start = moment(startsAt).startOf("day");
  const end = moment(endsAt).startOf("day");
  if (!start.isValid() || !end.isValid() || end.isBefore(start)) return [];

  const out: PermitReleaseEntry[] = [];
  let cursor = start.clone();
  while (cursor.isSameOrBefore(end)) {
    const usedOn = cursor.format("YYYY-MM-DD");
    const releasesOn = cursor.clone().add(rollingDays, "days").format("YYYY-MM-DD");
    out.push({usedOn, releasesOn});
    cursor = cursor.add(1, "day");
  }
  return out;
}

/**
 * When the API reports fewer permit days than calendar days in the range, only the
 * most recent `permitDays` are counted (oldest days in the range drop off first).
 */
export function alignScheduleToPermitDays(
  schedule: PermitReleaseEntry[],
  permitDays: number,
): PermitReleaseEntry[] {
  if (permitDays <= 0 || schedule.length <= permitDays) return schedule;
  return schedule.slice(schedule.length - permitDays);
}

export function getEarliestPermitReleaseDate(schedules: PermitReleaseEntry[][]): string | null {
  let earliest: string | null = null;
  for (const schedule of schedules) {
    for (const entry of schedule) {
      if (earliest == null || entry.releasesOn < earliest) {
        earliest = entry.releasesOn;
      }
    }
  }
  return earliest;
}
